module.exports = __webpack_public_path__ + "img/scene3copy03.37bbebcf.png";